import { CALL_API/* , Schemas */ } from '../store/api';

export const UPDATE_REPORT_FILTERS = 'UPDATE_REPORT_FILTERS';
export const CLEAR_REPORT_FILTERS = 'CLEAR_REPORT_FILTERS';
export const MGMT_REPORT_TOTAL_REQUEST = 'MGMT_REPORT_TOTAL_REQUEST';
export const MGMT_REPORT_TOTAL_SUCCESS = 'MGMT_REPORT_TOTAL_SUCCESS';
export const MGMT_REPORT_TOTAL_FAILURE = 'MGMT_REPORT_TOTAL_FAILURE';
export const MGMT_REPORT_COURTESY_REQUEST = 'MGMT_REPORT_COURTESY_REQUEST';
export const MGMT_REPORT_COURTESY_SUCCESS = 'MGMT_REPORT_COURTESY_SUCCESS';
export const MGMT_REPORT_COURTESY_FAILURE = 'MGMT_REPORT_COURTESY_FAILURE';
export const MGMT_REPORT_SUSPENSION_REQUEST = 'MGMT_REPORT_SUSPENSION_REQUEST';
export const MGMT_REPORT_SUSPENSION_SUCCESS = 'MGMT_REPORT_SUSPENSION_SUCCESS';
export const MGMT_REPORT_SUSPENSION_FAILURE = 'MGMT_REPORT_SUSPENSION_FAILURE';
export const MGMT_REPORT_FINE_REQUEST = 'MGMT_REPORT_FINE_REQUEST';
export const MGMT_REPORT_FINE_SUCCESS = 'MGMT_REPORT_FINE_SUCCESS';
export const MGMT_REPORT_FINE_FAILURE = 'MGMT_REPORT_FINE_FAILURE';
export const MGMT_REPORT_VIOLATION_TYPE_REQUEST = 'MGMT_REPORT_VIOLATION_TYPE_REQUEST';
export const MGMT_REPORT_VIOLATION_TYPE_SUCCESS = 'MGMT_REPORT_VIOLATION_TYPE_SUCCESS';
export const MGMT_REPORT_VIOLATION_TYPE_FAILURE = 'MGMT_REPORT_VIOLATION_TYPE_FAILURE';
export const REPORT_COMPANY_LIST_REQUEST = 'REPORT_COMPANY_LIST_REQUEST';
export const REPORT_COMPANY_LIST_SUCCESS = 'REPORT_COMPANY_LIST_SUCCESS';
export const REPORT_COMPANY_LIST_FAILURE = 'REPORT_COMPANY_LIST_FAILURE';
export const MGMT_REPORT_VCBYTYPE_REQUEST = 'MGMT_REPORT_VCBYTYPE_REQUEST';
export const MGMT_REPORT_VCBYTYPE_SUCCESS = 'MGMT_REPORT_VCBYTYPE_SUCCESS';
export const MGMT_REPORT_VCBYTYPE_FAILURE = 'MGMT_REPORT_VCBYTYPE_FAILURE';
export const MGMT_REPORT_CORRECTEDVC_REQUEST = 'MGMT_REPORT_CORRECTEDVC_REQUEST';
export const MGMT_REPORT_CORRECTEDVC_SUCCESS = 'MGMT_REPORT_CORRECTEDVC_SUCCESS';
export const MGMT_REPORT_CORRECTEDVC_FAILURE = 'MGMT_REPORT_CORRECTEDVC_FAILURE';

export const SET_FIRM = 'SET_FIRM';
export const RESET_FIRM = 'RESET_FIRM';
export const FIRM_REPORT_TOTAL_REQUEST = 'FIRM_REPORT_TOTAL_REQUEST';
export const FIRM_REPORT_TOTAL_SUCCESS = 'FIRM_REPORT_TOTAL_SUCCESS';
export const FIRM_REPORT_TOTAL_FAILURE = 'FIRM_REPORT_TOTAL_FAILURE';
export const FIRM_REPORT_SUSPENSION_REQUEST = 'FIRM_REPORT_SUSPENSION_REQUEST';
export const FIRM_REPORT_SUSPENSION_SUCCESS = 'FIRM_REPORT_SUSPENSION_SUCCESS';
export const FIRM_REPORT_SUSPENSION_FAILURE = 'FIRM_REPORT_SUSPENSION_FAILURE';
export const FIRM_REPORT_VIOLATION_TYPE_REQUEST = 'FIRM_REPORT_VIOLATION_TYPE_REQUEST';
export const FIRM_REPORT_VIOLATION_TYPE_SUCCESS = 'FIRM_REPORT_VIOLATION_TYPE_SUCCESS';
export const FIRM_REPORT_VIOLATION_TYPE_FAILURE = 'FIRM_REPORT_VIOLATION_TYPE_FAILURE';
export const FIRM_REPORT_VCBYTYPE_REQUEST = 'FIRM_REPORT_VCBYTYPE_REQUEST';
export const FIRM_REPORT_VCBYTYPE_SUCCESS = 'FIRM_REPORT_VCBYTYPE_SUCCESS';
export const FIRM_REPORT_VCBYTYPE_FAILURE = 'FIRM_REPORT_VCBYTYPE_FAILURE';
export const FIRM_REPORT_CORRECTEDVC_REQUEST = 'FIRM_REPORT_CORRECTEDVC_REQUEST';
export const FIRM_REPORT_CORRECTEDVC_SUCCESS = 'FIRM_REPORT_CORRECTEDVC_SUCCESS';
export const FIRM_REPORT_CORRECTEDVC_FAILURE = 'FIRM_REPORT_CORRECTEDVC_FAILURE';
export const FIRM_REPORT_FINE_REQUEST = 'FIRM_REPORT_FINE_REQUEST';
export const FIRM_REPORT_FINE_SUCCESS = 'FIRM_REPORT_FINE_SUCCESS';
export const FIRM_REPORT_FINE_FAILURE = 'FIRM_REPORT_FINE_FAILURE';

export const REPORT_AGENT_LIST_REQUEST = 'REPORT_AGENT_LIST_REQUEST';
export const REPORT_AGENT_LIST_SUCCESS = 'REPORT_AGENT_LIST_SUCCESS';
export const REPORT_AGENT_LIST_FAILURE = 'REPORT_AGENT_LIST_FAILURE';

export const SET_AGENT = 'SET_AGENT';
export const RESET_AGENT = 'RESET_AGENT';
export const AGENT_REPORT_TOTAL_REQUEST = 'AGENT_REPORT_TOTAL_REQUEST';
export const AGENT_REPORT_TOTAL_SUCCESS = 'AGENT_REPORT_TOTAL_SUCCESS';
export const AGENT_REPORT_TOTAL_FAILURE = 'AGENT_REPORT_TOTAL_FAILURE';
export const AGENT_REPORT_FINE_REQUEST = 'AGENT_REPORT_FINE_REQUEST';
export const AGENT_REPORT_FINE_SUCCESS = 'AGENT_REPORT_FINE_SUCCESS';
export const AGENT_REPORT_FINE_FAILURE = 'AGENT_REPORT_FINE_FAILURE';
export const AGENT_REPORT_VCBYTYPE_REQUEST = 'AGENT_REPORT_VCBYTYPE_REQUEST';
export const AGENT_REPORT_VCBYTYPE_SUCCESS = 'AGENT_REPORT_VCBYTYPE_SUCCESS';
export const AGENT_REPORT_VCBYTYPE_FAILURE = 'AGENT_REPORT_VCBYTYPE_FAILURE';
export const AGENT_REPORT_CORRECTEDVC_REQUEST = 'AGENT_REPORT_CORRECTEDVC_REQUEST';
export const AGENT_REPORT_CORRECTEDVC_SUCCESS = 'AGENT_REPORT_CORRECTEDVC_SUCCESS';
export const AGENT_REPORT_CORRECTEDVC_FAILURE = 'AGENT_REPORT_CORRECTEDVC_FAILURE';


export const updateReportFilters = (params) => (dispatch, getState) => {
    return dispatch({type: UPDATE_REPORT_FILTERS, params: params });
}

export const clearReportFilters = () => (dispatch, getState) => {
    return dispatch({type: CLEAR_REPORT_FILTERS });
}

export const fetchMgmtReportTotal = (body) => ({
    [CALL_API]: {
        types: [MGMT_REPORT_TOTAL_REQUEST, MGMT_REPORT_TOTAL_SUCCESS, MGMT_REPORT_TOTAL_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getviolationstats'
    }
});

export const fetchMgmtReportCourtesy = (body) => ({
    [CALL_API]: {
        types: [MGMT_REPORT_COURTESY_REQUEST, MGMT_REPORT_COURTESY_SUCCESS, MGMT_REPORT_COURTESY_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getcorrectedviolationcountaftercourtesysent'
    }
});

export const fetchMgmtReportSuspension = (body) => ({
    [CALL_API]: {
        types: [MGMT_REPORT_SUSPENSION_REQUEST, MGMT_REPORT_SUSPENSION_SUCCESS, MGMT_REPORT_SUSPENSION_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getsuspendedrlsusecount'
    }
});

export const fetchMgmtReportFine = (body) => ({
    [CALL_API]: {
        types: [MGMT_REPORT_FINE_REQUEST, MGMT_REPORT_FINE_SUCCESS, MGMT_REPORT_FINE_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getfineissued'
    }
});

export const fetchMgmtReportViolationTypeWise = (body) => ({
    [CALL_API]: {
        types: [MGMT_REPORT_VIOLATION_TYPE_REQUEST, MGMT_REPORT_VIOLATION_TYPE_SUCCESS, MGMT_REPORT_VIOLATION_TYPE_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getviolationbytypeperfirm'
    }
});

export const fetchMgmtReportViolationCountByType = (body) => ({
    [CALL_API]: {
        types: [MGMT_REPORT_VCBYTYPE_REQUEST, MGMT_REPORT_VCBYTYPE_SUCCESS, MGMT_REPORT_VCBYTYPE_FAILURE],
        method: 'POST',
        body: body,
        //endpoint: 'reports/getviolationcountbytype'
        endpoint: 'reports/getallviolationscount'
    }
});

export const fetchMgmtReportCorrectedViolationCount = (body) => ({
    [CALL_API]: {
        types: [MGMT_REPORT_CORRECTEDVC_REQUEST, MGMT_REPORT_CORRECTEDVC_SUCCESS, MGMT_REPORT_CORRECTEDVC_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getcorrectedviolationcount'
    }
});

export const fetchCompanies = (keyword) => ({
    [CALL_API]: {
        types: [REPORT_COMPANY_LIST_REQUEST, REPORT_COMPANY_LIST_SUCCESS, REPORT_COMPANY_LIST_FAILURE],
        method: 'GET',
        endpoint: 'reports/getcompanies/' + keyword
    }
});

export const setSelectedFirm = (params) => (dispatch, getState) => {
    return dispatch({type: SET_FIRM, params: params });
}

export const resetSelectedFirm = () => (dispatch, getState) => {
    return dispatch({type: RESET_FIRM });
}

export const fetchFirmReportTotal = (body) => ({
    [CALL_API]: {
        types: [FIRM_REPORT_TOTAL_REQUEST, FIRM_REPORT_TOTAL_SUCCESS, FIRM_REPORT_TOTAL_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getviolationstats'
    }
});

export const fetchFirmReportSuspension = (body) => ({
    [CALL_API]: {
        types: [FIRM_REPORT_SUSPENSION_REQUEST, FIRM_REPORT_SUSPENSION_SUCCESS, FIRM_REPORT_SUSPENSION_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getsuspendedrlsusecount'
    }
});

export const fetchFirmReportViolationTypeWise = (body) => ({
    [CALL_API]: {
        types: [FIRM_REPORT_VIOLATION_TYPE_REQUEST, FIRM_REPORT_VIOLATION_TYPE_SUCCESS, FIRM_REPORT_VIOLATION_TYPE_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getviolationbytypeperagent'
    }
});

export const fetchFirmReportViolationCountByType = (body) => ({
    [CALL_API]: {
        types: [FIRM_REPORT_VCBYTYPE_REQUEST, FIRM_REPORT_VCBYTYPE_SUCCESS, FIRM_REPORT_VCBYTYPE_FAILURE],
        method: 'POST',
        body: body,
        //endpoint: 'reports/getviolationcountbytype'
        endpoint: 'reports/getallviolationscount'
    }
});

export const fetchFirmReportCorrectedViolationCount = (body) => ({
    [CALL_API]: {
        types: [FIRM_REPORT_CORRECTEDVC_REQUEST, FIRM_REPORT_CORRECTEDVC_SUCCESS, FIRM_REPORT_CORRECTEDVC_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getcorrectedviolationcount'
    }
});

export const fetchFirmReportFine = (body) => ({
    [CALL_API]: {
        types: [FIRM_REPORT_FINE_REQUEST, FIRM_REPORT_FINE_SUCCESS, FIRM_REPORT_FINE_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getfineissued'
    }
});

export const fetchAgents = (keyword) => ({
    [CALL_API]: {
        types: [REPORT_AGENT_LIST_REQUEST, REPORT_AGENT_LIST_SUCCESS, REPORT_AGENT_LIST_FAILURE],
        method: 'GET',
        endpoint: 'reports/getagents/' + keyword
    }
});

export const setSelectedAgent = (params) => (dispatch, getState) => {
    return dispatch({type: SET_AGENT, params: params });
}

export const resetSelectedAgent = () => (dispatch, getState) => {
    return dispatch({type: RESET_AGENT });
}

export const fetchAgentReportTotal = (body) => ({
    [CALL_API]: {
        types: [AGENT_REPORT_TOTAL_REQUEST, AGENT_REPORT_TOTAL_SUCCESS, AGENT_REPORT_TOTAL_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getviolationstats'
    }
});

export const fetchAgentReportFine = (body) => ({
    [CALL_API]: {
        types: [AGENT_REPORT_FINE_REQUEST, AGENT_REPORT_FINE_SUCCESS, AGENT_REPORT_FINE_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getfineissued'
    }
});

export const fetchAgentReportViolationCountByType = (body) => ({
    [CALL_API]: {
        types: [AGENT_REPORT_VCBYTYPE_REQUEST, AGENT_REPORT_VCBYTYPE_SUCCESS, AGENT_REPORT_VCBYTYPE_FAILURE],
        method: 'POST',
        body: body,
        //endpoint: 'reports/getviolationcountbytype'
        endpoint: 'reports/getallviolationscount'
    }
});

export const fetchAgentReportCorrectedViolationCount = (body) => ({
    [CALL_API]: {
        types: [AGENT_REPORT_CORRECTEDVC_REQUEST, AGENT_REPORT_CORRECTEDVC_SUCCESS, AGENT_REPORT_CORRECTEDVC_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'reports/getcorrectedviolationcount'
    }
});